export enum PARSE_STATE {
    UPLOADING = 'uploading',
    PARSING = 'parsing',
    PARSED_SUCCESS = 'success',
    PARSED_ERROR = 'error',
    CANCELLED = 'cancelled'
}

export interface IActiveParsingResponse {
  RequestId: string;
  CvId: number;
};

export interface IActiveParsing {
  requestId: string;
  cvId: number;
  loading: boolean;
  error: boolean;
}

export enum BROADCAST_MESSAGES {
    CHECK_ACTIVE_PARSING = 'CHECK_ACTIVE_PARSING'
}
